<template>
  <div class="hvh-flex header-shadow">
    <header class="header hvh-flex space-between grow-1">
      <div class="logo-image hvh-flex align-center" :class="{ clickable: $route.name !== 'acticsLandingPage' }" @click="goTo({ name: 'acticsLandingPage' })">
        <img class="ml-4" :src="$loadImage(acticsLogoImage)" alt="ACTICS logo BY EVERSANA" />
      </div>
      <!-- <a class="ml-4" v-once href="/Home/?actics=1">
      </a> -->
      <div class="hvh-flex align-center" v-if="$store.state.user">
        <label class="font-md">{{ clientName || 'N/A' }}</label>
        <v-menu offset-y left attach v-if="(availableClients || []).any()">
          <template v-slot:activator="{ on }">
            <v-icon color="white" v-on="on">mdi-chevron-down</v-icon>
          </template>

          <div class="clients">
            <v-list class="px-3">
              <v-list-tile class="clickable" @click="selectClient(client.id)" v-for="client in availableClients" :key="client.id">
                <v-list-tile-title>{{ client.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </div>
        </v-menu>

        <div class="mr-1">
          <v-icon class="ml-3 mr-1" color="white" @click="showHelp" v-if="getFlag('DAS-1461')">mdi-help-circle-outline</v-icon>
          <v-icon class="ml-3" color="white">mdi-bell-outline</v-icon>
        </div>

        <v-menu offset-y left attach>
          <template v-slot:activator="{ on }">
            <v-avatar class="ml-3" size="30">
              <v-icon color="white">mdi-account-circle</v-icon>
              <!-- <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" /> -->
            </v-avatar>
            <v-icon class="mr-3" color="white" v-on="on">mdi-chevron-down</v-icon>
          </template>
          <v-list>
            <div class="hvh-nav__items">
              <a class="hvh-nav__subnav" :href="item.url" v-for="(item, ind) in navItems" :key="ind">
                <v-icon class="hvh-nav__icon">{{ item.icon }}</v-icon>
                {{ item.title }}
              </a>
            </div>
            <div class="hvh-nav__logout">
              <a href="/Account/Logout?actics=1" class="hvh-nav__subnav">
                <v-icon class="hvh-nav__icon">mdi-exit-to-app</v-icon>
                Log Out
              </a>
            </div>
          </v-list>
        </v-menu>
      </div>
    </header>
    <div class="copany-logo clickable" @click="goTo('/Client/Edit/10')" v-if="clientLogos[(clientName || '').toUpperCase()]">
      <img :src="$loadImage(clientLogos[clientName.toUpperCase()])" />
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import acticsLogoImage from '../../assets/images/actics/logo_actics.png';
import clientLogos from '../../assets/images/logos';
import { createFormData, errorDebug, tryParse, resolveAfterInactivity } from '../../libraries/common';
export default {
  data() {
    return {
      value: {
        items: [],
        logout: {},
      },
      availableClients: null,
      selectedClientId: null,
      acticsLogoImage,
      clientLogos,
      inactivityTimer: null,
    }
  },
  computed: {
    client() {
      return this.availableClients?.find(f => f.id === this.selectedClientId) || this.$store.state.user?.client;
    },
    clientName() {
      return this.client?.name;
    },
    navItems() {
      var user = this.$store.state.user;
      if (!user)
        return [];

      var { name, email } = user.user || {};

      var navItems = [
        {
          title: `Profile - ${name || email}`,
          url: '/Manage/Index',
          icon: 'mdi-account',
        },
        {
          title: 'Change Password',
          url: '/Manage/ChangePassword',
          icon: 'mdi-lock',
        },
        {
          title: 'Two-Factor Options',
          url: '/Manage/TwoFactorAuthentication',
          icon: 'mdi-cellphone-android',
        },
        (this.getFlag('das-247') && {
          title: 'Custom Feature List',
          url: '/CustomFeatureList/List',
          icon: 'mdi-cellphone-android',
        })
      ];

      if (user.isMainAdmin)
        navItems.pushMany([
          {
            title: 'Manage Analytics',
            url: '/Analytics/Analytic/Manage',
            icon: 'mdi-settings'
          },
          {
            title: 'Manage Clients',
            url: '/Client',
            icon: 'mdi-settings'
          },
          {
            title: 'Manage Admin Users',
            url: '/Manage/AdminUsers',
            icon: 'mdi-settings'
          },
          {
            title: 'Manage Users',
            url: '/Manage/AllApplicationUsers',
            icon: 'mdi-settings'
          },
          {
            title: 'Patient Data Sources',
            url: '/Analytics/ManagedPatientDataSource/Manage',
            icon: 'mdi-settings'
          },
          {
            title: 'Manage Auto Refresh',
            url: '/Refresh',
            icon: 'mdi-settings'
          },
          {
            title: 'Admin Help',
            url: '/Wiki/Wiki/AdminWiki',
            icon: 'mdi-settings'
          },
          {
            title: 'Statistics',
            url: '/Statistic',
            icon: 'mdi-settings'
          }
        ]);
      return navItems.filter(f => f);
    },
    incativityFlag() {
      return this.getFlag('DAS-1328');
    },
  },
  methods: {
    selectClient(selectedClient) {
      this.$store.state.isAppLoading = true;
      axios.post('/Account/PickClient', createFormData({ selectedClient }))
        .then(({ data }) => {
          this.selectedClientId = data;
          location.reload();
        })
        .catch(err => {
          errorDebug(err);
          this.$store.state.isAppLoading = false;
        });
    },
    startInactivityTimer() {
      if (!this.inactivityTimer) {
        this.inactivityTimer = resolveAfterInactivity(60 * 60 * 1000) // 60 mins
          .then(() => axios.get('/Account/DeleteLoginCookies'))
          .then(() => {
            location.reload();
            console.log('LogOut after inactiviy!');
          });
      }
    },
    showHelp() {
      var height = screen.height * .6;
      var width = screen.width * .6;
      var top = (screen.height - height) / 3;
      var left = (screen.width - width) / 2;

      var features = `height=${height},width=${width},top=${top},left=${left},status=yes`;

      var url = 'https://eversana.sharepoint.com/sites/Eversana-DataAnalytics/SitePages/ACTICS-Help-Center.aspx';

      window.open(url, 'Help Page', features);
    },
  },
  watch: {
    incativityFlag() {
      if (this.incativityFlag) {
        this.startInactivityTimer();
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsHeader'] = this;
    axios.get('/Account/GetAvailableClients')
      .then(({ data }) => {
        this.availableClients = data.clients;
        this.selectedClientId = tryParse(data.selectClientId);
      });

    if (this.incativityFlag) {
      this.startInactivityTimer();
    }
  },
}
</script>

<style lang="scss" scoped>
.header-shadow {
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  max-height: 100%;
  background-color: var(--header-bg-color);
  .header {
    background-color: var(--header-bg-color);
    width: 100%;
    height: 78px;
    color: white;
    .logo-image {
      img {
        width: 113px;
      }
    }

    .hvh-nav__subnav {
      padding-right: 50px;
    }

    .clients {
      max-height: 50vh;
    }
  }

  .copany-logo {
    display: flex;
    background-color: white;
    margin: 8px;
    border-radius: 2px;
    img {
      margin: auto 21px;
      width: 100px;
      max-height: 100%;
    }
  }
}
</style>